export default __webpack_public_path__ + "static/media/light_icon128.b7842b33.png";